import { OutletWrapper } from '@base'
import React from 'react'
import { Outlet } from 'react-router'

const Lead = () => {
	return (
		<OutletWrapper>
			<Outlet />
		</OutletWrapper>
	)
}

export default Lead
